export const PAYMENT_REQUESTS_STATUSES: any = {
  REQUEST_PENDING: 'pending',
  REQUEST_ACCEPTED: 'accepted',
  REQUEST_REJECTED: 'rejected',
  REQUEST_IN_PROGRESS: 'in_progress',
  REQUEST_PROCESSING: 'processing',
  REQUEST_RETURNED: 'returned',
};
